var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFingerIcon = function SvgFingerIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#545353",
    d: "m7.344 1.5-.157.14L3.798 5H1v8h8.422c.705 0 1.32-.498 1.468-1.187L11.72 8H13.5c.822 0 1.5-.678 1.5-1.5S14.322 5 13.5 5H8.125l.094-.375c.101-.078.166-.112.313-.312.233-.32.468-.817.468-1.485C9 2.115 8.355 1.5 7.547 1.5zm.359 1.047c.211.041.297.127.297.281 0 .452-.136.73-.266.907-.128.175-.218.218-.218.218l-.173.094-.061.203-.298 1.125L6.829 6H13.5c.283 0 .5.217.5.5s-.217.5-.5.5h-2.594l-.094.39-.89 4.22a.504.504 0 0 1-.5.39H4.5V5.703zM2 6h1.5v6H2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFingerIcon);
export default ForwardRef;